import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import styled from 'styled-components';
import PagesTopNav from "../components/TopNav/PagesTopNav";
import PageLayout from "../components/PageLayout";

// Styled Components
const ContactPageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const ContactCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
`;

const ContactIcon = styled.div`
  font-size: 2.5rem;
  color: #3498db;
  margin-bottom: 1.5rem;
`;

const ContactTitle = styled.h3`
  font-size: 1.4rem;
  color: #2c3e50;
  margin-bottom: 1rem;
`;

const ContactText = styled.p`
  color: #7f8c8d;
  line-height: 1.7;
  margin-bottom: 0.5rem;
`;

const ContactLink = styled.a`
  color: #3498db;
  text-decoration: none;
  transition: color 0.2s ease;
  
  &:hover {
    color: #2980b9;
    text-decoration: underline;
  }
`;

const ContactDescription = styled.div`
  max-width: 800px;
  margin: 0 auto 3rem;
  text-align: center;
  font-size: 1.1rem;
  line-height: 1.7;
  color: #34495e;
  padding: 0 1rem;
`;

const ContactUsPage = () => {
  return (
    <div>
      <PagesTopNav />
      <PageLayout 
        title="Contact Us" 
        description="Get in touch with our team for any inquiries or support"
      >
        <ContactPageContainer>
          {/* Removed duplicate <h1> header */}
          <ContactDescription>
            Get in touch with us for any inquiries, support, or partnership opportunities regarding 
            our hotel management solutions. Our Botswana-based team is ready to assist you.
          </ContactDescription>

          <ContactGrid>
            <ContactCard>
              <ContactIcon>
                <FaMapMarkerAlt />
              </ContactIcon>
              <ContactTitle>Our Location</ContactTitle>
              <ContactText>Plot 22211, Nshaiwa Street, Phase 4</ContactText>
              <ContactText>Gaborone, Botswana</ContactText>
            </ContactCard>

            <ContactCard>
              <ContactIcon>
                <FaPhone />
              </ContactIcon>
              <ContactTitle>Phone</ContactTitle>
              <ContactText>
                <ContactLink href="tel:+26776350228">+267 76 350 228</ContactLink>
              </ContactText>
              <ContactText>
                <FaClock style={{ marginRight: '8px' }} />
                Mon–Fri, 8am–5pm CAT
              </ContactText>
            </ContactCard>

            <ContactCard>
              <ContactIcon>
                <FaEnvelope />
              </ContactIcon>
              <ContactTitle>Email</ContactTitle>
              <ContactText>
                <ContactLink href="mailto:info@nnetego.com">info@nnetego.com</ContactLink>
              </ContactText>
            </ContactCard>
          </ContactGrid>
        </ContactPageContainer>
      </PageLayout>
    </div>
  );
};

export default ContactUsPage;
